export const spirometryMeasurementsValues = [
  "percent_predicted_fev1",
  "percent_predicted_fvc",
  "calculated_predicted_fev1",
  "calculated_predicted_fvc",
  "fev1",
  "fev25_75",
  "fvc",
  "fev1_fvc",
  "fev6",
  "pef",
];

export const archivableSpirometryMeasurements = [
  "calculated_predicted_fev1",
  "calculated_predicted_fvc",
  "fev1",
  "fev25_75",
  "fvc",
  "fev1_fvc",
];

// EN-3704: the spirometry quality filter hides blows by their FVC/FEV1
// acceptability. Predicted values are derived from those same blows, so they
// are filtered by the quality of the raw value they are calculated from.
export const spirometryQualityFilterTypes: Map<string, "fvc" | "fev1"> =
  new Map([
    ["fvc", "fvc"],
    ["calculated_predicted_fvc", "fvc"],
    ["fev1", "fev1"],
    ["calculated_predicted_fev1", "fev1"],
  ]);

export const spirometryMeasurementsValuesFilters = Array.from(
  spirometryQualityFilterTypes.keys()
);

export const tooltipTitles: Map<string, string> = new Map([
  ["fev1", "Fev 1"],
  ["pulse_ox", "Pulse Ox"],
  ["temperature", "Temperature"],
  ["diarrhoea", "Diarrhoea"],
  ["heart_rate", "Heart Rate"],
  ["height", "Height"],
  ["weight", "Weight"],
  ["fev25_75", "Fev 25/75"],
  ["dyspnea", "Breathlessness"],
  ["bp_systolic", "Systolic"],
  ["bp_diastolic", "Diastolic"],
  ["hemoglobin", "Hemoglobin"],
  ["blood_glucose", "Blood Glucose"],
  ["cni_trough", "CNI Trough"],
  ["barthel_index", "Barthel Index"],
  ["rockwood_index", "Rockwood Index"],
  ["respiratory_rate", "Respiratory Rate"],
  ["oxygen_rate", "Oxygen Rate"],
  ["fvc", "FVC"],
  ["fev1_fvc", "FEV1/FVC"],
  ["creatinine", "Creatinine"],
  ["gfr", "GFR"],
  ["white_cells", "White Cells"],
  ["psa", "PSA"],
  ["phosphate", "Phosphate"],
  ["sputum_volume", "Sputum Volume"],
  ["calculated_predicted_fvc", "Predicted FVC"],
  ["calculated_predicted_fev1", "Predicted FEV1"],
  ["pef", "PEF"],
  ["fev6", "FEV6"],
  ["dry_weight", "Dry Weight"],
  ["crp", "CRP"],
  ["esr", "ESR"],
  ["bkv", "BKV"],
  ["total_cholesterol", "Total Cholesterol"],
  ["plasma_glucose", "Plasma Glucose"],
  ["calcium", "Calcium"],
  ["hdl_cholesterol", "HDL Cholesterol"],
  ["ldl_cholesterol", "LDL Cholesterol"],
  ["corrected_calcium", "Corrected Calcium"],
  ["cf_dna", "cfDNA"],
  ["lab_gfr", "labGFR"],
  ["potassium", "Potassium"],
  ["tacrolimus_level", "Tacrolimus Level"],
  ["nebulizer", "Nebulizer"],
  ["daily_steps", "Steps"],
  ["arrhythmia_status", "Arrhythmia"],
  ["neutrophils", "Neutrophils"],
  ["uf_volume", "UF Volume"],
  ["dialysis_bp_systolic", "Systolic BP"],
  ["dialysis_bp_diastolic", "Diastolic BP"],
  ["dialysis_weight", "Weight"],
  ["-", "Value"],
]);

export const fibriCheckColorDictionary = {
  green: "success",
  blue: "info",
  orange: "tertiary",
  red: "error",
  grey: "warning",
};

export const defaultDataDisplayConfig = {
  calculated_predicted_fev1: "BestOfDay",
  calculated_predicted_fvc: "BestOfDay",
  fev1: "BestOfDay",
  fev25_75: "BestOfDay",
  fvc: "BestOfDay",
  fev1_fvc: "BestOfDay",
  fev6: "BestOfDay",
  pef: "BestOfDay",
  default: "",
};
